import { randomString, ABC } from '@lemonade-hq/ts-helpers';
import { css } from 'styled-components';
import { compose, color, system } from 'styled-system';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  pointer-events: none;\n  user-select: none;\n  cursor: not-allowed;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  border-radius: 50%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  background-color: transparent;\n  background-image: url(",
        ");\n  background-repeat: no-repeat;\n  background-position: ",
        "px ",
        "px;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    grid-template-columns: ",
        ";\n    grid-template-areas: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function cssValue(value) {
    var defaultUnit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
    if (Number.isNaN(Number(value)) && typeof value === "string") {
        return value;
    }
    return "".concat(value).concat(defaultUnit);
}
function conditionalInclude(condition, output) {
    return condition ? output : undefined;
}
function createAnimationDelayForChildren(initialDelay, delayInterval, maxChildren) {
    var cssString = "";
    for(var i = 0; i < maxChildren; i++){
        cssString += "&:nth-child(".concat(i, ") {\n            animation-delay: ").concat(initialDelay + delayInterval * i, "ms;\n        }\n        ");
    }
    return css(_templateObject(), cssString);
}
var textColor = compose(color, system({
    // Alias color as textColor
    textColor: {
        property: "color",
        scale: "colors"
    }
}));
function supportsCssVariables() {
    return typeof CSS !== "undefined" && typeof CSS.supports !== "undefined" && CSS.supports("color", "var(--fake-var)");
}
var disabledInteraction = css(_templateObject1());
var round = css(_templateObject2());
var ellipsis = css(_templateObject3());
var randomCssVar = function() {
    return "--".concat(randomString(10, ABC));
};
var spriteSheetIcon = function(spriteSheetUrl, param) {
    var _param_position = param.position, x = _param_position.x, y = _param_position.y, _param_size = param.size, width = _param_size.width, height = _param_size.height;
    return css(_templateObject4(), spriteSheetUrl, x, y, width, height);
};
function weightsToGridFr(weights) {
    return weights.map(function(w) {
        return "".concat(w * 10, "fr");
    }).join(" ");
}
function generateHexGridTemplate(layout) {
    var sortedLayout = _to_consumable_array(layout).sort(function(a, b) {
        return a - b;
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var longest = sortedLayout[sortedLayout.length - 1];
    var cssProps = function(gridTemplateAreas) {
        return css(_templateObject5(), longest, gridTemplateAreas);
    };
    var lastAssigned = 1;
    var layoutList = layout.reduce(function(list, row) {
        var dotsDifference = longest - row;
        var layoutIds = _to_consumable_array(Array(row).keys()).reduce(function(acc) {
            var id = "i".concat(lastAssigned);
            lastAssigned += 1;
            return "".concat(acc, " ").concat(id, " ").concat(id);
        }, "");
        if (dotsDifference) {
            var dots = _to_consumable_array(Array(dotsDifference).keys()).reduce(function(str) {
                return "".concat(str, " .");
            }, "");
            return _to_consumable_array(list).concat([
                "'".concat(dots, " ").concat(layoutIds, " ").concat(dots, "'")
            ]);
        }
        return _to_consumable_array(list).concat([
            "'".concat(layoutIds, "'")
        ]);
    }, []);
    return cssProps(layoutList.join(""));
}

export { conditionalInclude, createAnimationDelayForChildren, cssValue, disabledInteraction, ellipsis, generateHexGridTemplate, randomCssVar, round, spriteSheetIcon, supportsCssVariables, textColor, weightsToGridFr };
